import { Products as Product } from '@/@types';

type ProductProps = {
    info:string,
};

export default function ProductTabInfo({ info }: ProductProps) {
    return (
        <div className='p-8' dangerouslySetInnerHTML={{ __html: info }}></div>
    )
}
